import PropTypes from "prop-types";
import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import { translator } from "../../utils/i18n";

const useStyles = makeStyles(theme => ({
  appBar: {
    position: "relative"
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1
  }
}));

export default function Analyse(props) {
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        target="iframe1"
        href={props.item.urlMokajai}
        onClick={handleClickOpen}
      >
        {"Lancer l'analyse"}
      </Button>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              {translator()._("W_STEP_BOUTON_FERMER")}
            </Typography>
          </Toolbar>
        </AppBar>
        <iframe
          name="iframe1"
          className="iframe-fullwidth"
          title="alaxIframe"
        />
      </Dialog>
    </div>
  );
}

Analyse.propTypes = {
  item: PropTypes.shape({
    urlMokajai: PropTypes.string
  })
};
